import { createContext, useContext, useEffect, useState, useCallback } from "react";

const T = {
  id: {
    "nav.beranda": "Beranda",
    "nav.about": "Tentang",
    "nav.reach": "Jangkauan",
    "nav.services": "Layanan",
    "nav.products": "Produk",
    "nav.works": "Karya",
    "nav.insights": "Insights",
    "nav.clients": "Klien",
    "nav.contact": "Kontak",
    "nav.cta": "Mulai Proyek",
    "nav.openMenu": "Buka menu",
    "nav.closeMenu": "Tutup menu",
    "nav.contactUs": "Hubungi Kami",

    "hero.title": "Mulai perjalanan digital bisnis Anda bersama kami.",
    "hero.scroll": "Gulir",

    "about.eyebrow": "Tentang Kami",
    "about.titleA": "Kami membangun",
    "about.titleHL": "kepercayaan",
    "about.titleB": "melalui kerja yang jujur dan terukur.",
    "about.body":
      "Kami memandang konsultasi sebagai kemitraan, bukan transaksi. Itu sebabnya setiap engagement dimulai dengan memahami konteks bisnis Anda secara mendalam sebelum menulis baris kode atau menggambar pixel pertama.",
    "about.cta": "Tentang Pendekatan Kami",
    "about.p1.title": "Kejernihan",
    "about.p1.desc":
      "Setiap keputusan diawali dengan pertanyaan yang tepat dan kerangka berpikir yang dapat dipertanggungjawabkan.",
    "about.p2.title": "Kelayakan",
    "about.p2.desc":
      "Solusi yang kami rancang harus dapat dijalankan tim Anda — bukan hanya indah di atas presentasi.",
    "about.p3.title": "Kesinambungan",
    "about.p3.desc":
      "Hasil bukan tujuan akhir; momentum jangka panjang adalah ukuran keberhasilan yang sebenarnya.",

    "reach.title": "We are connecting professionals across Indonesia.",

    "services.intro": "Empat disiplin untuk transformasi digital yang menyeluruh.",
    "services.menyeluruh": "menyeluruh",

    "products.eyebrow": "Produk",
    "products.intro": "Solusi tervertikalisasi, dirancang untuk konteks operasional Indonesia.",
    "products.learn": "Pelajari",

    "works.eyebrow": "Karya Pilihan",
    "works.client": "Klien",
    "works.year": "Tahun",
    "works.impact": "Dampak",
    "works.viewCase": "Lihat Studi Kasus",
    "works.prevNext": "Sebelumnya / Berikutnya",
    "works.caseStudy": "Studi Kasus",

    "insights.eyebrow": "Insights",
    "insights.title": "Catatan dari ruang kerja kami.",
    "insights.readMore": "Baca Selengkapnya",
    "insights.readingTime": "menit baca",
    "insights.back": "Kembali ke Insights",

    "clients.titleA": "Dipercaya oleh",
    "clients.titleHL": "120+ brand",
    "clients.titleB": "di Indonesia.",

    "contact.title": "Mari berbincang.",
    "contact.titleHL": "berbincang",
    "contact.titleA": "Mari",
    "contact.name": "Nama",
    "contact.namePh": "Nama lengkap Anda",
    "contact.email": "Email",
    "contact.emailPh": "nama@perusahaan.com",
    "contact.businessName": "Nama Bisnis",
    "contact.businessNamePh": "PT. Contoh Indonesia",
    "contact.businessLinks": "Link Bisnis (opsional)",
    "contact.businessLinksPh": "Instagram: @bisnis, Website: contoh.com, dll.",
    "contact.budget": "Budget Anda (AUD)",
    "contact.budget.option1": "Dibawah $300 (Landing page sederhana)",
    "contact.budget.option2": "$300-800 (Website bisnis)",
    "contact.budget.option3": "$800-1500 (E-commerce atau fitur kompleks)",
    "contact.budget.option4": "$1500+ (Platform custom)",
    "contact.budget.option5": "Belum yakin",
    "contact.demo": "Sertakan demo cepat sebelum build lengkap",
    "contact.demoInfo": "Demo cepat dibuat dalam 24-48 jam sehingga Anda bisa melihat konsep live sebelum komit ke proyek penuh. Biaya demo (+$20 atau 10% dari quotation, mana yang lebih tinggi) akan dikurangkan dari harga final jika Anda lanjut.",
    "contact.subject": "Subjek",
    "contact.subjectPh": "Topik singkat yang ingin dibahas",
    "contact.message": "Pesan",
    "contact.messagePh": "Ceritakan konteks, tujuan, dan tantangan proyek Anda…",
    "contact.send": "Kirim Pesan",
    "contact.sending": "Mengirim…",
    "contact.emailLabel": "Email",
    "contact.phoneLabel": "Telepon",
    "contact.officeLabel": "Kantor Pusat",
    "contact.officeBody":
      "Jl. Jenderal Sudirman Kav. 52–53\nSCBD, Jakarta Selatan 12190\nIndonesia",
    "contact.branchLabel": "Cabang Operasional",
    "contact.branchBody": "Jakarta · Bandung · Surabaya · Batam",
    "contact.backTop": "Kembali ke awal",
    "contact.toastEmpty": "Mohon lengkapi nama, email, dan pesan terlebih dahulu.",
    "contact.toastNoConfig": "Konfigurasi EmailJS belum tersedia.",
    "contact.toastSuccess": "Terima kasih — pesan Anda telah kami terima.",
    "contact.toastFail": "Pesan gagal terkirim. Mohon coba beberapa saat lagi.",
    "contact.subjectDefault": "Pertanyaan baru dari website Makario",

    "footer.tagline":
      "Konsultan teknologi independen yang membantu organisasi Indonesia merancang, membangun, dan menjalankan produk digital yang bermakna.",
    "footer.explore": "Jelajahi",
    "footer.disciplines": "Disiplin Layanan",
    "footer.rights": "Seluruh hak cipta dilindungi.",
    "footer.privacy": "Kebijakan Privasi",
    "footer.terms": "Syarat Layanan",
    "footer.madeIn": "Dibuat dengan presisi di Indonesia.",

    "detail.client": "Klien",
    "detail.year": "Tahun",
    "detail.industry": "Industri",
    "detail.scope": "Lingkup",
    "detail.impact": "Dampak",
    "detail.challenge": "Tantangan",
    "detail.approach": "Pendekatan",
    "detail.outcome": "Hasil",
    "detail.back": "Kembali",
    "detail.notFound": "Halaman tidak ditemukan.",
  },
  en: {
    "nav.beranda": "Home",
    "nav.about": "About",
    "nav.reach": "Reach",
    "nav.services": "Services",
    "nav.products": "Products",
    "nav.works": "Works",
    "nav.insights": "Insights",
    "nav.clients": "Clients",
    "nav.contact": "Contact",
    "nav.cta": "Start a Project",
    "nav.openMenu": "Open menu",
    "nav.closeMenu": "Close menu",
    "nav.contactUs": "Contact Us",

    "hero.title": "Start your business digital journey with us.",
    "hero.scroll": "Scroll",

    "about.eyebrow": "About Us",
    "about.titleA": "We build",
    "about.titleHL": "trust",
    "about.titleB": "through honest, measurable work.",
    "about.body":
      "We see consulting as a partnership, not a transaction. That's why every engagement begins by deeply understanding your business context — long before any code is written or pixel is drawn.",
    "about.cta": "About Our Approach",
    "about.p1.title": "Clarity",
    "about.p1.desc":
      "Every decision begins with the right questions and a framework you can defend.",
    "about.p2.title": "Feasibility",
    "about.p2.desc":
      "Solutions we design must be runnable by your team — not just pretty in a deck.",
    "about.p3.title": "Continuity",
    "about.p3.desc":
      "Outcomes aren't the finish line; long-term momentum is the true measure of success.",

    "reach.title": "We are connecting professionals across Indonesia.",

    "services.intro": "Four disciplines for a holistic digital transformation.",
    "services.menyeluruh": "holistic",

    "products.eyebrow": "Products",
    "products.intro": "Verticalised solutions, designed for Indonesian operating realities.",
    "products.learn": "Learn more",

    "works.eyebrow": "Selected Works",
    "works.client": "Client",
    "works.year": "Year",
    "works.impact": "Impact",
    "works.viewCase": "View Case Study",
    "works.prevNext": "Previous / Next",
    "works.caseStudy": "Case Study",

    "insights.eyebrow": "Insights",
    "insights.title": "Notes from our studio.",
    "insights.readMore": "Read More",
    "insights.readingTime": "min read",
    "insights.back": "Back to Insights",

    "clients.titleA": "Trusted by",
    "clients.titleHL": "120+ brands",
    "clients.titleB": "across Indonesia.",

    "contact.title": "Let's talk.",
    "contact.titleHL": "talk",
    "contact.titleA": "Let's",
    "contact.name": "Name",
    "contact.namePh": "Your full name",
    "contact.email": "Email",
    "contact.emailPh": "name@company.com",
    "contact.businessName": "Business Name",
    "contact.businessNamePh": "Smith's Coffee Shop",
    "contact.businessLinks": "Business Links (optional)",
    "contact.businessLinksPh": "Instagram: @yourbusiness, Website: example.com, etc.",
    "contact.budget": "Your Budget (AUD)",
    "contact.budget.option1": "Under $300 (Quick landing page)",
    "contact.budget.option2": "$300-800 (Business website)",
    "contact.budget.option3": "$800-1500 (E-commerce or complex features)",
    "contact.budget.option4": "$1500+ (Custom platform)",
    "contact.budget.option5": "Not sure yet",
    "contact.demo": "Include quick demo before full build",
    "contact.demoInfo": "Quick demos are built in 24-48h so you can see your concept live before committing to the full project. Demo cost (+$20 or 10% of quote, whichever is higher) is deducted from final price if you proceed.",
    "contact.subject": "Subject",
    "contact.subjectPh": "A brief topic to discuss",
    "contact.message": "Message",
    "contact.messagePh": "Tell us your context, goals, and challenges…",
    "contact.send": "Send Message",
    "contact.sending": "Sending…",
    "contact.emailLabel": "Email",
    "contact.phoneLabel": "Phone",
    "contact.officeLabel": "Headquarters",
    "contact.officeBody":
      "Jl. Jenderal Sudirman Kav. 52–53\nSCBD, South Jakarta 12190\nIndonesia",
    "contact.branchLabel": "Operational Branches",
    "contact.branchBody": "Jakarta · Bandung · Surabaya · Batam",
    "contact.backTop": "Back to top",
    "contact.toastEmpty": "Please complete name, email, and message first.",
    "contact.toastNoConfig": "EmailJS configuration is missing.",
    "contact.toastSuccess": "Thank you — we have received your message.",
    "contact.toastFail": "Failed to send. Please try again shortly.",
    "contact.subjectDefault": "New inquiry from Makario website",

    "footer.tagline":
      "An independent technology consultancy helping Indonesian organisations design, build, and run meaningful digital products.",
    "footer.explore": "Explore",
    "footer.disciplines": "Service Disciplines",
    "footer.rights": "All rights reserved.",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
    "footer.madeIn": "Crafted with precision in Indonesia.",

    "detail.client": "Client",
    "detail.year": "Year",
    "detail.industry": "Industry",
    "detail.scope": "Scope",
    "detail.impact": "Impact",
    "detail.challenge": "Challenge",
    "detail.approach": "Approach",
    "detail.outcome": "Outcome",
    "detail.back": "Back",
    "detail.notFound": "Page not found.",
  },
};

const LangContext = createContext({ lang: "id", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("makario_lang") || "en";
  });

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    setLangState(next);
    try { window.localStorage.setItem("makario_lang", next); } catch (e) {}
  }, []);

  const t = useCallback((key) => {
    return (T[lang] && T[lang][key]) || (T.id && T.id[key]) || key;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useT() {
  return useContext(LangContext);
}
